<template>
  <anchor-modal
    eager
    light
    max-width="600"
    transition="dialog-bottom-transition"
    header-color="white"
    :header-split="true"
    :title="originator ? `Edit Teams - ${originator.display_name}` : 'Edit Teams'"
    :persistent="loading"
    v-model="display"
  >
    <div class="text-center">
      <label>
        Use the form below to add users to the selected team.
      </label>
    </div>
    <v-form ref="form" v-model="valid">
      <v-row>
        <v-col class="pb-0">
          <v-select
            dense
            required
            outlined
            id="team-form-role-select"
            label="Select Team"
            :items="options"
            :rules="rules.role_id"
            v-model="model.role_id"
          />
          <v-autocomplete
            outlined
            dense
            disable-sort
            id="team-form-user-select"
            item-value="_id"
            item-text="display_name"
            label="Select New User"
            :disabled="error || !model.role_id"
            :loading="loading"
            :items="selectableUsers"
            :filter="filterHandler"
            :rules="rules.user_id"
            v-model="model.user_id"
          />
        </v-col>
      </v-row>
      <div class="d-flex mb-4">
        <v-spacer />
        <v-btn
          id="team-form-cancel-btn"
          @click="display = false"
        >
          Cancel
        </v-btn>
        <v-btn
          id="team-form-save-btn"
          color="primary"
          class="ml-3"
          :disabled="!valid || loading"
          :loading="loading"
          @click="submit"
        >
          Save
        </v-btn>
      </div>
    </v-form>
  </anchor-modal>
</template>

<script>
/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */

import roleMixin from '@/mixins/roleMixin';
import userMixin from '@/mixins/userMixin';

import MODEL from './resources/model';
import RULES from './resources/rules';


export default {
  name: 'AdminGroupsEditTeamModal',
  mixins: [roleMixin, userMixin],
  props: {
    originator: Object,
    groups: Object,
    roles: Array,
  },
  data: () => ({
    display: false,
    valid: false,
    loading: false,
    error: false,
    model: {},
    rules: RULES,
    users: [],
  }),
  computed: {
    options() {
      if (!this.roles) { return []; }
      return this.roles
        .map(role => ({ text: `${this.originatorTitles[role.title]}s`, value: role._id }));
    },
    selectableUsers() {
      if (!this.model.role_id) { return this.users; }

      return this.users.filter(user => {
        const selectedUsers = this.groups ? this.groups[this.model.role_id].map(u => u._id) : [];
        const matchRole = user.roles.includes(this.roles.find(r => r._id === this.model.role_id).title);
        return !selectedUsers.includes(user._id) && matchRole;
      });
    },
  },
  methods: {
    open() {
      this.$refs.form.reset();

      const mdl = this.$utils.deepCopy(MODEL.originator);
      mdl.originator_id = this.originator._id;
      this.model = mdl;

      this.display = true;
    },
    filterHandler(item, queryText) {
      const text = item.display_name.toLowerCase();
      const searchText = queryText.toLowerCase();
      return text.indexOf(searchText) > -1;
    },
    fetch() {
      this.loading = true;
      this.error = null;
      const params = { active_only: true };
      this.$requests.get('/v1/users', { params })
        .then(response => {
          this.users = this.resolveUsers(response.data);
        })
        .catch(() => {
          this.error = true;
          this.$toast.error('Could not resolve list of users...', { timeout: 3000 });
        })
        .then(() => { this.loading = false; });
    },
    submit() {
      if (!this.$refs.form.validate()) { return; }

      this.loading = true;
      this.$requests.post('/v1/originator-work-team', null, { params: this.model })
        .then(() => {
          this.$toast.success('New user successfully saved!', { timeout: 3000 });
          this.$emit('success', this.model.role_id);
          this.$refs.form.reset();
        })
        .catch(e => {
          const reason = e.response.data?.message || '';
          this.$toast.error(`Could not add the user to team. ${reason}`, { timeout: 5000 });
        })
        .then(() => { this.loading = false; });
    },
  },
  watch: {
    display(value) {
      if (value && !this.users.length) {
        this.fetch();
      } else if (!value) {
        this.$refs.form.reset();
        this.model = {};
        this.error = null;
      }
    },
  },
};
</script>
